export const tvpilVersion = '3.39.0-feat-KUX-1090.764';
